export const theme = {
    placeholderColor: "rgb(217, 217, 217)",
    mainColor: "#dadada",
    mainHoverColor: "#aaaaaa",
    itemHoverColor: "rgba(0, 255, 0, 0.05)",
    itemBorderColor: "#26a826",
    errorColor: "#e74343"
}